import type { Transaction } from "@/model/DataModel"

export function formatConstructionYears(
	transaction: Pick<Transaction, "constructionYearMin" | "constructionYearMax">
): string {
	const { constructionYearMin: min, constructionYearMax: max } = transaction
	if (min == null || max == null) return ""
	return min === max ? String(min) : `${min}–${max}`
}

export function formatPropertyUses(transaction: Pick<Transaction, "propertyUses">): string {
	return (transaction.propertyUses ?? []).map(propertyUse => propertyUse.label).join(", ")
}
